/**
 * Modulo Console
 * @module abstracts/console
 * @namespace Abstracts/Console
 */
import _ from 'underscore'
import Core from '../core'
import { getQueryVariable } from '../../libs/utils'

/**
 * Classe responsável por cadastrar e disparar eventos
 *
 * @name Console
 * @typedef {Object} Console
 * @memberof abstracts/console
 */
class Console {
    /**
     * Constructor da classe Console
     *
     * @return {void}
     */
    constructor () {
        this._show = false
        this._console = {}
    }

    /**
     * Inicializador manual da classe Console
     *
     * @return {void}
     */
    init () {
        Core.Status.update('console', 'status', 'started')

        this._console = _.clone(window.console)

        this.setPrefix()

        this._setShow()

        this._replaceWindowConsole()

        Core.Status.update('console', 'status', 'finished')
    }

    /**
     * Substitui o método console.log
     *
     * @return {void}
     */
    log (...logs) {
        if (this._show) {
            if (logs.length === 1) {
                this._console.log(`%c ${this.prefix}`, this._getStylePrefix(), logs[0])
            } else {
                this._console.log(
                    `%c ${this.prefix}%c ${logs.shift()}`,
                    this._getStylePrefix(), this._getStyle(),
                    (logs.length === 1) ? logs[0] : logs
                )
            }
        }
    }

    /**
     * Substitui o método console.warn
     *
     * @return {void}
     */
    warn (...logs) {
        if (this._show) {
            if (logs.length === 1) {
                this._console.warn(logs[0])
            } else {
                this._console.warn(
                    `%c ${this.prefix}%c ${logs.shift()}`,
                    this._getStylePrefix(), this._getStyle(),
                    (logs.length === 1) ? logs[0] : logs
                )
            }
        }
    }

    /**
     * Substitui o método console.error
     *
     * @return {void}
     */
    error (...logs) {
        if (this._show) {
            if (logs.length === 1) {
                this._console.error(logs[0])
            } else {
                this._console.error(
                    `%c ${this.prefix}%c ${logs.shift()}`,
                    this._getStylePrefix(), this._getStyle(),
                    (logs.length === 1) ? logs[0] : logs
                )
            }
        }
    }

    /**
     * Substitui o método console.info
     *
     * @return {void}
     */
    info (...logs) {
        if (this._show) {
            if (logs.length === 1) {
                this._console.info(logs[0])
            } else {
                this._console.info(
                    `%c ${this.prefix}%c ${logs.shift()}`,
                    this._getStylePrefix(), this._getStyle(),
                    (logs.length === 1) ? logs[0] : logs
                )
            }
        }
    }

    /**
     * Substitui o método console.table
     *
     * @return {void}
     */
    table (...logs) {
        if (this._show) {
            if (logs.length === 1) {
                this._console.table(logs[0])
            } else {
                this._console.table(logs)
                // this._console.table(
                //     `%c ${this.prefix}%c ${logs.shift()}`,
                //     this._getStylePrefix(), this._getStyle(),
                //     (logs.length === 1) ? logs[0] : logs
                // );
            }
        }
    }

    /**
     * Seta o prefixo exibido nos consoles
     *
     * @return {void}
     */
    setPrefix (prefix = 'Gazeta do Povo') {
        this.prefix = prefix
    }

    /**
     * Seta a propriedade this.Show como true caso exista a querystring '_showSecureGPLogs';
     *
     * @return {void}
     */
    _setShow () {
        // Variável definida pela query string, ignora a configuração da Stage
        this._show = (getQueryVariable('_showSecureGPLogs') === 'true')
    }

    /**
     * Substitui o método global window.console por essa classe, caso seja ambiente de produção
     *
     * @return {void}
     */
    _replaceWindowConsole () {
        // Se o stage for igual produção substitui a biblioteca padrão de console
        if (Core.Config.get('stage') === 'prd') {
            window.console = this
        }
    }

    /**
     * Define o estilo do prefixo do console
     *
     * @return {void}
     */
    _getStylePrefix () {
        // tslint:disable
        return 'background: #2D5875; color: #fff; border-radius: 4px; padding: 2px; padding-right: 8px; margin-right: 7px;'
    }

    /**
     * Define o estido da referência do console
     *
     * @return {void}
     */
    _getStyle () {
        // tslint:disable
        return 'background: #e3e3e3; color: #000; border-radius: 4px; padding: 2px; padding-right: 8px;'
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Console = Console
